module.exports = __webpack_public_path__ + "account/img/249.03d146ef.png";